import React from 'react';
import { Search, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="pt-28 pb-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" id="inicio" data-id="element-130">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-131">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl" data-id="element-132">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-sm font-medium mb-6" data-id="element-133">
            <span className="relative flex h-2 w-2" data-id="element-134">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75" data-id="element-135"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500" data-id="element-136"></span>
            </span>
            Tu próxima gran lectura te espera
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 leading-[1.1] mb-6 tracking-tight" data-id="element-137">
            Descubre mundos
            <br data-id="element-138" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-500" data-id="element-139">
              página a página.
            </span>
          </h1>

          <p className="text-lg text-slate-600 mb-8 max-w-lg leading-relaxed" data-id="element-140">
            Explora nuestra cuidada selección de e-books. Desde bestsellers
            internacionales hasta joyas ocultas en ficción, tecnología y
            desarrollo personal.
          </p>

          {/* Search Bar */}
          <div className="relative max-w-md mb-8" data-id="element-141">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-142">
              <Search className="h-5 w-5 text-slate-400" data-id="element-143" />
            </div>
            <input type="text" className="block w-full pl-11 pr-32 py-4 bg-white border border-slate-200 rounded-full text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 shadow-sm transition-all" placeholder="Título, autor o género" data-id="element-144" />
            <button className="absolute inset-y-1.5 right-1.5 px-6 bg-slate-900 hover:bg-indigo-600 text-white text-sm font-medium rounded-full transition-colors flex items-center gap-2" data-id="element-145">
              Buscar
            </button>
          </div>

          <div className="flex items-center gap-6 text-sm text-slate-500 font-medium" data-id="element-146">
            <div className="flex -space-x-2" data-id="element-147">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-slate-200 flex items-center justify-center text-xs overflow-hidden" data-id="element-148">
                  <img src={`https://i.pravatar.cc/100?img=${i + 10}`} alt="User" className="w-full h-full object-cover" data-id="element-149" />
                </div>)}
            </div>
            <p data-id="element-150">+10,000 lectores activos</p>
          </div>
        </motion.div>

        {/* Visual / Featured Book */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative lg:ml-auto w-full max-w-md mx-auto" data-id="element-151">
          {/* Decorative background */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-indigo-100/50 to-blue-50/50 rounded-full blur-3xl -z-10" data-id="element-152"></div>

          <div className="relative bg-white p-6 rounded-3xl shadow-xl border border-white/50 backdrop-blur-sm" data-id="element-153">
            <div className="absolute -top-4 -right-4 bg-amber-400 text-amber-950 text-xs font-bold px-3 py-1.5 rounded-full shadow-lg transform rotate-12" data-id="element-154">
              ¡Más vendido!
            </div>

            <div className="w-full aspect-[2/3] rounded-r-xl rounded-l-sm shadow-2xl overflow-hidden flex flex-col items-center justify-center p-8 text-center bg-gradient-to-br from-slate-800 to-slate-900 relative" style={{
            boxShadow: 'inset 6px 0 15px rgba(0,0,0,0.3), inset -2px 0 4px rgba(255,255,255,0.1), 10px 20px 30px rgba(0,0,0,0.15)'
          }} data-id="element-155">
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-black/30" data-id="element-156"></div>
              <div className="absolute left-2 top-0 bottom-0 w-0.5 bg-white/10" data-id="element-157"></div>

              <p className="text-slate-300 text-sm uppercase tracking-[0.2em] mb-4 font-medium" data-id="element-158">
                Elena Navarro
              </p>
              <h3 className="text-white font-bold text-3xl leading-tight mb-6" data-id="element-159">
                El Eco del
                <br data-id="element-160" />
                Tiempo
              </h3>
              <div className="w-12 h-1 bg-indigo-500 rounded-full mb-6" data-id="element-161"></div>
              <p className="text-slate-400 text-xs" data-id="element-162">Novela de Ficción</p>
            </div>

            <div className="mt-6 flex items-center justify-between" data-id="element-163">
              <div data-id="element-164">
                <p className="text-sm text-slate-500" data-id="element-165">Precio especial</p>
                <p className="text-2xl font-bold text-slate-900" data-id="element-166">$14.99</p>
              </div>
              <button className="flex items-center gap-2 bg-slate-900 text-white px-5 py-2.5 rounded-full text-sm font-medium hover:bg-indigo-600 transition-colors" data-id="element-167">
                Comprar ahora
                <ArrowRight className="w-4 h-4" data-id="element-168" />
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}